import { useNosIdMutation } from '@/hooks/api/base.hooks';
import { personalInfoQueryOptions } from '@/hooks/api/personal-info.hooks';
import { auth } from '@/lib';
import { api } from '@/portal-api.definition';
import { useQueryClient } from '@tanstack/react-query';
import { ActionType, useI18n, useToast } from '@nosinovacao/nosid-mfe-common';
import { loginOptionsQueryOptions } from '@/routes/(home)/-hooks/login-options.hook';

interface UseRemoveUsernameConfig {
  onSuccess?: () => void;
  onError?: () => void;
}

export function useRemoveUsername({ onSuccess, onError }: UseRemoveUsernameConfig = {}) {
  const toast = useToast();
  const { t } = useI18n();
  const queryClient = useQueryClient();

  return useNosIdMutation({
    mutationFn: async () => {
      const userId = (await auth.getUserId()) ?? '';
      return api.delete('/api/v1/personal-info/username-alias', {
        search: { 'x-user-id': userId },
      });
    },
    successLogAction: () => ({ ActionType: ActionType.Submit, Option: 'LoginOptions' }),
    errorLogAction: () => ({ ActionType: ActionType.Submit, Option: 'LoginOptions' }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: personalInfoQueryOptions.queryKey });
      queryClient.invalidateQueries({ queryKey: loginOptionsQueryOptions.queryKey });
      toast.show('success', t('Common.SnackBar.UsernameRemoved'));
      onSuccess?.();
    },
    onError,
  });
}
